// Validation for incoming chat responses against the strict JSON contract.
// See docs/CHAT-JSON-CONTRACT.md.
//
// SECURITY NOTE: this is the gate at the boundary — responses that fail
// validation are rejected before they can reach the renderer. Rendering
// safety itself comes from `MessageBlocks.vue` using Vue's `{{ }}`
// interpolation (auto-escaped), not from this validation. A `text` block
// whose `value` contains `<script>` is a VALID response — it just gets
// rendered as literal characters by the renderer, not as a script tag.

export const KNOWN_BLOCK_TYPES = new Set(['text', 'notice', 'image', 'file']);

const BLOCKS_WITH_STRING_VALUE = new Set(['text', 'notice']);

// An image/file is fetched (or downloaded) by the browser, so it may only
// point at our own proxy path. Anything absolute would let a response choose
// a host for the client.
const IMAGE_URL_PREFIX = '/api/chat-attachment/';
const FILE_URL_PREFIX = '/api/chat-file/';

const VALIDATION_BASE_URL = 'https://chat-validation.internal';

function _isSameOriginProxyUrl(url, prefix) {
  if (typeof url !== 'string') { return false; }
  let parsed;
  try {
    parsed = new URL(url, VALIDATION_BASE_URL);
  } catch (error) {
    return false;
  }
  return parsed.origin === VALIDATION_BASE_URL && parsed.pathname.startsWith(prefix);
}

export function isValidResponse(json) {
  if (!json || typeof json !== 'object' || !Array.isArray(json.blocks)) { return false; }
  return json.blocks.every(isValidBlock);
}

export function isValidBlock(b) {
  if (!b || typeof b !== 'object' || !KNOWN_BLOCK_TYPES.has(b.type)) { return false; }
  if (BLOCKS_WITH_STRING_VALUE.has(b.type) && typeof b.value !== 'string') { return false; }
  if (b.type === 'image') {
    return _isSameOriginProxyUrl(b.url, IMAGE_URL_PREFIX);
  }
  if (b.type === 'file') {
    return _isSameOriginProxyUrl(b.url, FILE_URL_PREFIX);
  }
  return true;
}
